import { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { PATH_MAIN } from '../routes/paths';

type RegistrationCompletionGuardProps = {
    registrationCompleted: boolean;
    /** Also admit registered clients whose medical intake is still incomplete. */
    allowIncompleteIntake?: boolean;
    children: ReactNode;
};

const RegistrationCompletionGuard: FC<RegistrationCompletionGuardProps> = ({
    registrationCompleted,
    allowIncompleteIntake = false,
    children,
}) => {
    const { user } = useAuth();

    const intakeOutstanding =
        allowIncompleteIntake &&
        Boolean(user?.isRegistrationComplete) &&
        user?.clientProfile?.isIntakeComplete === false;

    if (user && user.isRegistrationComplete !== registrationCompleted && !intakeOutstanding) {
        window.open('', '_self');
        window.close();

        if (!window.closed) {
            return <Navigate to={PATH_MAIN.general.dashboard} replace />;
        }

        return null;
    }

    return <>{children}</>;
};

export default RegistrationCompletionGuard;
